import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class SideTray extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);

    this.scene = scene;

    this.colorArray = [
      [147,12,35],
      [206,21,21],
      [255,91,69],
      [163,77,20],
      [237,118,0],
      [255,158,31],
      [168,103,0],
      [237,169,0],
      [255,249,46],
      [86,135,0],
      [142,188,0],
      [216,255,54],
      [12,145,12],
      [51,193,22],
      [124,252,41],
      [0,124,91],
      [0,170,113],
      [39,226,141],
      [11,113,153],
      [30,158,193],
      [37,218,232],
      [22,29,147],
      [36,58,211],
      [36,115,255],
      [99,23,130],
      [154,34,175],
      [229,46,225],
      [168,24,141],
      [216,43,154],
      [255,82,161],
      [119,44,18],
      [155,74,42],
      [173,108,30],
      [136,129,140],
      [187,180,191],
      [255,255,255],
      [0,0,0],
      [64,57,66],
      [100,93,102]
    ];

    this.menuClicked = false;
    this.mirrorClicked = false;
    this.eraserClicked = false;
    this.bucketClicked = false;
    this.paintClicked = true;
    this.sizeClicked = false;
    this.colorClicked = false;

    this.menuBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 70, 'button1', null, () => {
      this.handleMenu();
    }, this, { disabledTint: 0xFFFFFF });


    this.mirrorBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 160, 'mirror_both_button', null, () => {
      this.handleGrid();
    }, this, { disabledTint: 0xFFFFFF });
    this.mirrorBtn.upIMG = 'mirror_both_button';
    this.mirrorBtn.downIMG = 'mirror_both_buttonb';


    this.undoBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 250, 'button3', 'button3b', () => {
      this.handleUndo();
    }, this, { disabledTint: 0xFFFFFF });


    this.eraserBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 340, 'button4', null, () => {
      this.eraserBtn.setEnabled(false);
      this.bucketBtn.setEnabled(true);
      this.paintBtn.setEnabled(true);

      this.handleEraser();
    }, this, { disabledTint: 0xFFFFFF });


    this.bucketBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 430, 'button5', null, () => {
      this.eraserBtn.setEnabled(true);
      this.bucketBtn.setEnabled(false);
      this.paintBtn.setEnabled(true);

      this.handleBucket();
    }, this, { disabledTint: 0xFFFFFF });


    this.paintBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 520, 'button6b', null, () => {
      this.eraserBtn.setEnabled(true);
      this.bucketBtn.setEnabled(true);
      this.paintBtn.setEnabled(false);

      this.handlePaint();
    }, this, { disabledTint: 0xFFFFFF }).setEnabled(false);


    this.sizeBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 610, 'brush_small_button', null, () => {
      this.handleSize();
    }, this, { disabledTint: 0xFFFFFF });
    this.sizeBtn.downIMG = 'brush_small_buttonb';
    this.sizeBtn.upIMG = 'brush_small_button';


    this.colorBtn = ABCyaPhaser.Buttons.addSimpleButton(60, 700, 'button8', null, () => {
      this.handleColor();
    }, this, { disabledTint: 0xFFFFFF });
    this.bgColor = this.scene.add.rectangle(this.colorBtn.x, this.colorBtn.y, this.colorBtn.getBounds().width - 20, this.colorBtn.getBounds().height - 20, 0x000000);
    this.add(this.bgColor);
    this.moveBelow(this.bgColor, this.colorBtn);

    this.btns = [this.menuBtn, this.mirrorBtn, this.undoBtn, this.eraserBtn, this.bucketBtn, this.paintBtn, this.sizeBtn, this.colorBtn];
  }

  initTray() {
    this.emit('BRUSH_ON');
    this.setCurrentStrokeColor([0,0,0]);
    this.emit('GRID_CLICKED', 1);
    this.emit('SIZE_CLICKED', 1);
  }


  //
  // BUTTON HANDLERS
  //
  handleMenu() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.menuClicked === false) {
      this.resetBtns(false);
      this.toggleBtns(false);
      this.menuBtn.setEnabled(true);

      this.menuClicked = true;
      this.menuBtn.setFrame('button1b');

      this.emit('MENU_OPEN');
    }
    else {
      this.menuClicked = false;
      this.menuBtn.setFrame('button1');
      this.toggleBtns(true);

      this.emit('MENU_CLOSE');
    }
  }

  handleGrid() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.mirrorClicked === false) {
      this.resetBtns(false);

      this.openMirrorTray();

      this.mirrorClicked = true;
      this.mirrorBtn.setFrame(this.mirrorBtn.downIMG);
    }
    else {
      this.mirrorClicked = false;
      this.mirrorBtn.setFrame(this.mirrorBtn.upIMG);

      if (this.mirrorBtns) {
        while (this.mirrorBtns.length > 0) {
          const btn = this.mirrorBtns.shift();
          btn.setEnabled(false);
          btn.destroy();
        }
      }
    }
  }

  handleUndo() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    this.resetBtns(false);

    this.emit('UNDO_CLICKED');
  }

  handleEraser() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.eraserClicked === false) {
      this.resetBtns();

      this.eraserClicked = true;
      this.eraserBtn.setFrame('button4b');

      this.emit('ERASER_ON');
    }
  }

  handleBucket() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.bucketClicked === false) {
      this.resetBtns();

      this.bucketClicked = true;
      this.bucketBtn.setFrame('button5b');

      this.emit('BUCKET_ON');
    }
  }

  handlePaint() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.paintClicked === false) {
      this.resetBtns();

      this.paintClicked = true;
      this.paintBtn.setFrame('button6b');

      this.emit('BRUSH_ON');
    }
  }

  handleSize() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.sizeClicked === false) {
      this.resetBtns(false);

      this.openSizeTray();

      this.sizeClicked = true;
      this.sizeBtn.setFrame(this.sizeBtn.downIMG);
    }
    else {
      this.sizeClicked = false;
      this.sizeBtn.setFrame(this.sizeBtn.upIMG);

      if (this.sizeBtns) {
        while (this.sizeBtns.length > 0) {
          const btn = this.sizeBtns.shift();
          btn.setEnabled(false);
          btn.destroy();
        }
      }
    }
  }

  handleColor() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

    if (this.colorClicked === false) {
      this.resetBtns(false);

      this.openColorTray();

      this.colorClicked = true;
      this.colorBtn.setFrame('button8b');
    }
    else {
      this.colorTray?.destroy();

      this.colorClicked = false;
      this.colorBtn.setFrame('button8');
    }
  }


  //
  // OPEN TRAY FUNCTIONS
  //
  openMirrorTray() {
    const btnQ = ABCyaPhaser.Buttons.addSimpleButton(this.mirrorBtn.x + this.mirrorBtn.getBounds().width + 15, this.mirrorBtn.y, 'mirror_both_button', 'mirror_both_buttonb', () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.resetBtns(false);

      this.mirrorBtn.downIMG = 'mirror_both_buttonb';
      this.mirrorBtn.upIMG = 'mirror_both_button';
      this.mirrorBtn.setFrame(this.mirrorBtn.upIMG);

      this.emit('GRID_CLICKED', 1);
    }, this, { disabledTint: 0xFFFFFF });

    const btnH = ABCyaPhaser.Buttons.addSimpleButton(btnQ.x + btnQ.getBounds().width + 15, this.mirrorBtn.y, 'mirror_horizontal_button', 'mirror_horizontal_buttonb', () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.resetBtns(false);

      this.mirrorBtn.downIMG = 'mirror_horizontal_buttonb';
      this.mirrorBtn.upIMG = 'mirror_horizontal_button';
      this.mirrorBtn.setFrame(this.mirrorBtn.upIMG);

      this.emit('GRID_CLICKED', 2);
    }, this, { disabledTint: 0xFFFFFF });

    const btnV = ABCyaPhaser.Buttons.addSimpleButton(btnH.x + btnH.getBounds().width + 15, this.mirrorBtn.y, 'mirror_vertical_button', 'mirror_vertical_buttonb', () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.resetBtns(false);

      this.mirrorBtn.downIMG = 'mirror_vertical_buttonb';
      this.mirrorBtn.upIMG = 'mirror_vertical_button';
      this.mirrorBtn.setFrame(this.mirrorBtn.upIMG);

      this.emit('GRID_CLICKED', 3);
    }, this, { disabledTint: 0xFFFFFF });

    this.mirrorBtns = [btnQ, btnH, btnV];
  }

  openSizeTray() {
    const btnS = ABCyaPhaser.Buttons.addSimpleButton(this.sizeBtn.x + this.sizeBtn.getBounds().width + 15, this.sizeBtn.y, 'brush_small_button', 'brush_small_buttonb', () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.resetBtns(false);

      this.sizeBtn.downIMG = 'brush_small_buttonb';
      this.sizeBtn.upIMG = 'brush_small_button';
      this.sizeBtn.setFrame(this.sizeBtn.upIMG);

      this.emit('SIZE_CLICKED', 1);
    }, this, { disabledTint: 0xFFFFFF });

    const btnM = ABCyaPhaser.Buttons.addSimpleButton(btnS.x + btnS.getBounds().width + 15, this.sizeBtn.y, 'brush_medium_button', 'brush_medium_buttonb', () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.resetBtns(false);

      this.sizeBtn.downIMG = 'brush_medium_buttonb';
      this.sizeBtn.upIMG = 'brush_medium_button';
      this.sizeBtn.setFrame(this.sizeBtn.upIMG);

      this.emit('SIZE_CLICKED', 2);
    }, this, { disabledTint: 0xFFFFFF });

    const btnL = ABCyaPhaser.Buttons.addSimpleButton(btnM.x + btnM.getBounds().width + 15, this.sizeBtn.y, 'brush_large_button', 'brush_large_buttonb', () => {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

      this.resetBtns(false);

      this.sizeBtn.downIMG = 'brush_large_buttonb';
      this.sizeBtn.upIMG = 'brush_large_button';
      this.sizeBtn.setFrame(this.sizeBtn.upIMG);

      this.emit('SIZE_CLICKED', 3);
    }, this, { disabledTint: 0xFFFFFF });

    this.sizeBtns = [btnS, btnM, btnL];
  }

  openColorTray() {
    this.colorTray = this.scene.add.container();
    this.add(this.colorTray);

    this.colorTray.setPosition(200, this.scene.mid.y * 2 - 384);

    const bg = ABCyaPhaser.Images.addImage(0, 0, 'color_dialog', this.colorTray);

    let posY = 52;
    for (let i = 0; i < 39; i++) {
      const button = ABCyaPhaser.Buttons.addSimpleButton(0, 0, `c${i + 1}`, null, () => {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);

        this.resetBtns(false);

        this.setCurrentStrokeColor(this.colorArray[i]);
      }, this.colorTray, { disabledTint: 0xFFFFFF });

      button.x = 15 + ((button.getBounds().width + 20) * (i % 3)) - 60;
      if (i % 3 === 0 && i > 0) {
        posY += button.getBounds().height + 22;
      }

      button.y = posY - 380;
    }
  }


  //
  // MISC AND HELPER FUNCTIONS
  //
  makeHexString(dec1, dec2, dec3) {
    let a = dec1.toString(16);
    if (a.length === 1) {
      a = `0${a}`;
    }

    let b = dec2.toString(16);
    if (b.length === 1) {
      b = `0${b}`;
    }

    let c = dec3.toString(16);
    if (c.length === 1) {
      c = `0${c}`;
    }

    const str = `#${a}${b}${c}`;
    return str;
  }

  toggleBtns(toggle) {
    this.btns.forEach((btn) => {
      btn.setEnabled(toggle);
    });
  }

  resetBtns(resetAll = true) {
    console.log('RESETTING');
    this.menuClicked = false;
    this.menuBtn.setFrame('button1');

    this.mirrorClicked = false;
    this.mirrorBtn.setFrame(this.mirrorBtn.upIMG);

    if (resetAll) {
      this.eraserClicked = false;
      this.eraserBtn.setFrame('button4');

      this.bucketClicked = false;
      this.bucketBtn.setFrame('button5');

      this.paintClicked = false;
      this.paintBtn.setFrame('button6');
    }

    this.sizeClicked = false;
    this.sizeBtn.setFrame(this.sizeBtn.upIMG);

    this.colorClicked = false;
    this.colorBtn.setFrame('button8');

    if (this.mirrorBtns) {
      while (this.mirrorBtns.length > 0) {
        const btn = this.mirrorBtns.shift();
        btn.setEnabled(false);
        btn.destroy();
      }
    }

    if (this.sizeBtns) {
      while (this.sizeBtns.length > 0) {
        const btn = this.sizeBtns.shift();
        btn.setEnabled(false);
        btn.destroy();
      }
    }

    this.colorTray?.destroy();
  }

  setCurrentStrokeColor(cArray) {
    const currentStrokeColor = Phaser.Display.Color.RGBToString(cArray[0], cArray[1], cArray[2]);
    const newColor = Phaser.Display.Color.GetColor(cArray[0], cArray[1], cArray[2]);

    this.bgColor.setFillStyle(newColor);

    this.emit('COLOR_CLICKED', currentStrokeColor);
  }
}